/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useUserStore from '../../../store/userStore/userStore';

interface GetReportBuilderUsersOptions {
  page?: number;
  limit?: number;
}

const getReportBuilderUsers = async (
  search: string,
  options: GetReportBuilderUsersOptions = {}
): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const {company} = useUserStore.getState().userDetails;
  const params: Record<string, string | number> = {search};
  if (typeof options.page === 'number') {
    params.page = options.page;
  }
  if (typeof options.limit === 'number') {
    params.limit = options.limit;
  }

  const url = `${API_BASE_URL}${API_ENDPOINT_JSON.reportBuilderUsers}/${company}`;

  try {
    const res: any = await axios.request({
      method: CRUDMethods.GET,
      url,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params
    });

    return res.data.data;
  } catch (err) {
    return [];
  }
};

export default getReportBuilderUsers;
